export default "__VITE_ASSET__BHsLsNAO__";